module.exports = __webpack_public_path__ + "static/media/img3.2e6049a3.jpg";